import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import AuthLayout from "../../layout/AuthLayout";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useCountry from "../../components/hooks/useCountry";
import { buildAuthModalState } from "../../routes/authModal";
import {
  resendOtp,
  varifyOtp,
  varifyForgotPassOtp,
} from "../../redux/actions/authAction";

const OtpVarification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const [isResending, setIsResending] = useState(false);
    const countryData = useCountry();
  const identifier = location?.state?.identifier || "";
  const redirectFrom = location?.state?.redirectFrom || "";
  const { isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    const storedExpiry = localStorage.getItem("otp_expiry");

    if (storedExpiry) {
      const remainingTime = Math.floor((storedExpiry - Date.now()) / 1000);

      if (remainingTime > 0) {
        setTimer(remainingTime);
      } else {
        localStorage.removeItem("otp_expiry");
      }
    }
  }, []);

  const handleOtpSubmit = () => {
    if (otp?.length != 4) {
     return toast.error("Please enter the 4-digit OTP");
    }

    const callback = (res) => {
      if (res?.success) {
        navigate(webPaths?.ResetPassword, {
          state: buildAuthModalState(location, {
            identifier: identifier,
          }),
        });
      }
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);
    const payload = {
      otp,
      ...(isEmail ? { email: identifier } : { phone_no: `${countryData?.country_calling_code}${identifier}` }),
    };

    if (redirectFrom == webPaths?.Signup) {
      dispatch(
        varifyOtp({
          payload,
          callback,
        }),
      );
    } else if (redirectFrom == webPaths?.ForgotPassword) {
      dispatch(
        varifyForgotPassOtp({
          payload,
          callback,
        }),
      );
    }
  };

  const handleResendOtp = () => {
    if (timer > 0) return;

    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);

    const payload = isEmail ? { email: identifier } : { phone_no: `${countryData?.country_calling_code}${identifier}` };

    const callback = (res) => {
      if (res?.success) {
        setOtp("");
        const expiryTime = Date.now() + 60000; // 60 sec
        localStorage.setItem("otp_expiry", expiryTime);
        setTimer(60); // 🔥 start countdown
      }
      setIsResending(false);
    };

    setIsResending(true);

    dispatch(
      resendOtp({
        payload,
        callback,
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AuthLayout>
      <div class="col-lg-12 mx-auto  login-popup__left ct_custom_scroll">
        <div>
          <div>
            <div>
              <div class="login-popup__brand mb-3">
                <img
                  onClick={() => {
                    navigate(webPaths?.WebHome);
                  }}
                  style={{ cursor: "pointer" }}
                  src="/assets/img/logo_black.png"
                  class="main-logo"
                  alt="SecurPoint"
                />
              </div>

              <h5 class="login-popup__title mb-2 ct_fs_28 text-center">
                OTP Verification
              </h5>
              <p class="ct_fs_15 ct_fw_500 text-center">
                A 4-digit code has been sent to {identifier}
              </p>
            </div>

            <div class="login-popup__roles mt-4">
              <div class="otpmainbox">
                <OtpInput
                  class="form-control ct_input"
                  inputType="number"
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                />
              </div>
            </div>

            <a
              onClick={(e) => {
                e.preventDefault();
                handleOtpSubmit();
                // navigate(webPaths?.ResetPassword);
              }}
              class="btn mt-4 ct_green_bnt ct_white_nowrap w-100"
            >
              Confirm Code
            </a>

            <p className="ct_fs_15 ct_fw_500 mt-3 text-center mb-0">
              Didn’t receive OTP?{" "}
              {timer > 0 ? (
                <span className="ct_green_text">Resend in {timer}s</span>
              ) : (
                <span
                  onClick={handleResendOtp}
                  style={{ cursor: "pointer" }}
                  className="ct_fs_15 ct_fw_600 ct_green_text"
                >
                  {isResending ? "Sending..." : "Resend Code"}
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVarification;
